import axios from "axios";
import * as apiConstant from "./apiConstant";
import $ from "jquery/dist/jquery.js";
/****************************************
    leadership management API
    @author  UYM
    @date    2020.5.14
    @version 0.1    
 ******************************************/
class logApi {
  static log(data) {
    var lang_key = localStorage.getItem("language");
    var url = `${apiConstant.API_URL}/log`;
    axios.post(url, data).then();
  }
}

export default logApi;
